exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".-IBFvEk-1CJPDEjEXApF4{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden}", ""]);
// Exports
exports.locals = {
	"compactRecipientRow": "-IBFvEk-1CJPDEjEXApF4"
};